/** `apps/web/index.html` 의 부팅 대기 화면. `#root` 밖에 있어 React 가 갈아 끼우지 않는다. */
export const BOOT_ELEMENT_ID = 'boot';

/** styles.css `#boot` 의 opacity 전환 길이와 같다 — 전환이 끝난 뒤 지운다. */
export const BOOT_FADE_MS = 250;

/**
 * 부팅 대기 화면(캐릭터)을 흐리게 사라지게 한 뒤 지운다. 첫 실제 화면이 그려질 때
 * `routes/BootDismissOutlet` 이 부른다 — 여러 번 불려도 한 번만 한다.
 *
 * 대기 화면이 React 요소였을 때는 복원이 끝나는 커밋에서 한 번에 빠져, 캐릭터가 설정 화면으로
 * 뚝 바뀌었다. 문서에 박힌 요소로 두면 네이티브 셸이 스플래시를 내린 뒤(onLoadEnd)부터 첫
 * 화면까지 한 요소가 계속 덮고, 사라지는 순간에만 전환이 걸린다. 감소된 모션은 styles.css 가
 * 전환을 끈다 — 그때도 제거는 같은 타이머로 한다.
 */
export const dismissBoot = (doc: Document = document): void => {
  const el = doc.getElementById(BOOT_ELEMENT_ID);
  if (!el || el.dataset.leaving !== undefined) {
    return;
  }
  el.dataset.leaving = '';
  setTimeout(() => el.remove(), BOOT_FADE_MS);
};
